export { ApiClient } from "./core/api-client";
export { CookieTokenStorage } from "./storage/token-storage";
export { HttpService } from "./services/http-service";
export { DEFAULT_SERVICES } from "./config/default-config";
export type { ServiceConfig, TokenStorage } from "./types";

// Create and export default instance
import { ApiClient } from "./core/api-client";
const apiClient = new ApiClient();
export default apiClient;
